import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// FlashMsgs Redux States
import {
  GET_FLASH_MSGS,
  GET_FLASH_MSG,
  CREATE_FLASH_MSG,
  DELETE_FLASH_MSG,
  EDIT_FLASH_MSG,
} from "./actionTypes";
import {
  setFlashMsgs,
  apiError,
  setFlashMsg,
  createFlashMsgSuccess,
  editFlashMsgSuccess,
  deleteFlashMsgSuccess,
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getFlashMsgs() {
  try {
    const response = yield call(axios.get, `/flash-message`);
    if (
      (response.status >= 200 || response.status <= 299) &&
      response?.data?.data
    ) {
      yield put(setFlashMsgs(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message = error.message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* createFlashMsg({ payload: { newFlashMsgValues } }) {
  try {
    let response = yield call(axios.post, `/flash-message`, newFlashMsgValues);

    if ((response.status >= 200 || response.status <= 299) && response?.data) {
      yield put(createFlashMsgSuccess(response.data));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getFlashMsg({ payload: { idFlashMsg } }) {
  try {
    let response = yield call(
      axios.get,
      `/flash-message?${idFlashMsg ? `&id=${idFlashMsg}` : ""}`
    );

    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setFlashMsg(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* editFlashMsg({ payload: { idFlashMsg, newFlashMsgValues } }) {
  try {
    let response = yield call(
      axios.patch,
      `/flash-message?${idFlashMsg ? `&id=${idFlashMsg}` : ""}`,
      newFlashMsgValues
    );

    if (
      (response.status >= 200 || response.status <= 299) &&
      response?.data?.message
    ) {
      let message = response.data.message;
      yield put(editFlashMsgSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* deleteFlashMsg({ payload: { idFlashMsg } }) {
  try {
    let response = yield call(
      axios.delete,
      `/flash-message?${idFlashMsg ? `&id=${idFlashMsg}` : ""}`
    );

    if (
      (response.status >= 200 || response.status <= 299) &&
      response?.data?.message
    ) {
      let message = response.data.message ? response.data.message : "";
      yield put(deleteFlashMsgSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

export function* watchGetFlashMsgs() {
  yield takeEvery(GET_FLASH_MSGS, getFlashMsgs);
}
export function* watchGetFlashMsg() {
  yield takeEvery(GET_FLASH_MSG, getFlashMsg);
}
export function* watchCreateFlashMsg() {
  yield takeEvery(CREATE_FLASH_MSG, createFlashMsg);
}
export function* watchEditFlashMsg() {
  yield takeEvery(EDIT_FLASH_MSG, editFlashMsg);
}
export function* watchDeleteFlashMsg() {
  yield takeEvery(DELETE_FLASH_MSG, deleteFlashMsg);
}
function* authSaga() {
  yield all([
    fork(watchGetFlashMsgs),
    fork(watchCreateFlashMsg),
    fork(watchGetFlashMsg),
    fork(watchEditFlashMsg),
    fork(watchDeleteFlashMsg),
  ]);
}

export default authSaga;
